export default __webpack_public_path__ + "static/media/fondo2.b7101cb5.png";